import { cn } from "@/lib/utils";
import type { ComponentPropsWithoutRef, ElementType, ReactElement, ReactNode } from "react";

type TextSize = "lead" | "body" | "small" | "helper" | "meta";

const textSizes: Record<TextSize, string> = {
  lead: "text-lg leading-relaxed text-pretty text-gray-600 sm:text-xl",
  body: "text-base leading-7 text-pretty text-gray-600",
  small: "text-sm leading-6 text-gray-600",
  helper: "text-xs leading-5 text-gray-500",
  meta: "text-sm leading-6 text-gray-500",
};

interface TextProps extends Omit<ComponentPropsWithoutRef<"p">, "children"> {
  as?: ElementType;
  children: ReactNode;
  size?: TextSize;
}

export function Text({ as: Component = "p", children, className, size = "body", ...props }: TextProps): ReactElement {
  return (
    <Component className={cn(textSizes[size], className)} {...props}>
      {children}
    </Component>
  );
}
